/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Section_ScoreInputs */

const en_directory_detail_section_score = /** @type {(inputs: Directory_Detail_Section_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score breakdown`)
};

const zh_directory_detail_section_score = /** @type {(inputs: Directory_Detail_Section_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评分拆解`)
};

/**
* | output |
* | --- |
* | "Score breakdown" |
*
* @param {Directory_Detail_Section_ScoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_section_score = /** @type {((inputs?: Directory_Detail_Section_ScoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Section_ScoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_section_score(inputs)
	return zh_directory_detail_section_score(inputs)
});
export { directory_detail_section_score as "directory.detail.section.score" }